import { createAction } from "redux-act";

export const OpenNewPhaseModalAction = createAction("New Phase - Open Modal");
export const CloseNewPhaseModalAction = createAction("New Phase - Close Modal");
